import React from 'react';
import { Link } from 'react-router-dom';
import { SignedIn, SignedOut, useClerk } from '@clerk/clerk-react';
import { useLifely } from '../../context/LifelyContext';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Loader2, LogIn, Shield } from 'lucide-react';

const AuthWrapper = ({ children }) => {
  const { authLoading } = useLifely();
  const { openSignIn } = useClerk();

  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center space-y-4">
          <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <SignedOut>
        <div className="flex items-center justify-center min-h-[60vh] px-4">
          <Card className="w-full max-w-md border-2">
            <CardHeader className="text-center space-y-4">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
                <Shield className="w-8 h-8 text-primary" />
              </div>
              <div>
                <CardTitle className="text-2xl">Welcome to Lifely</CardTitle>
                <CardDescription className="mt-2">
                  Your calm space for mapping what matters. Sign in to access your data.
                </CardDescription>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-sm text-muted-foreground text-center">
                Sign in to your Lifely account to continue.
              </p>

              <Button
                className="w-full"
                size="lg"
                onClick={() => openSignIn()}
                data-testid="sign-in-btn"
              >
                <LogIn className="w-4 h-4 mr-2" />
                Sign In
              </Button>

              <p className="text-xs text-muted-foreground text-center">
                Don&apos;t have an account?{' '}
                <Link
                  to="/join/pricing"
                  className="text-primary hover:underline"
                  data-testid="create-account-link"
                >
                  Create one
                </Link>
              </p>
            </CardContent>
          </Card>
        </div>
      </SignedOut>
      <SignedIn>
        {children}
      </SignedIn>
    </>
  );
};

export default AuthWrapper;
